/* versie 2 — luisteraar op document */
/*
  Norvela — bundelblok.

  Twee taken:
  1. Klik je op "2 dekens", dan zet dit script het aantal op 2.
  2. Kies je een andere maat of kleur, dan rekent het de bedragen opnieuw uit.
     Zonder dat tweede bleef het blok hangen op de prijs van de maat die bij het
     laden geselecteerd was — dan zag je bij 230 x 230 nog de bedragen van 150 x 200.

  De korting zelf regelt Shopify via een automatische kortingsregel op aantal.
  Dit blok laat alleen zien dat hij bestaat.
*/
(function () {
  'use strict';

  function lees(blok) {
    /* Shopify hijst dit JSON-blokje soms buiten het bundelblok, dus we zoeken
       eerst binnenin en anders in de hele pagina. */
    var el =
      blok.querySelector('[data-nv-bundel-prijzen]') ||
      document.querySelector('[data-nv-bundel-prijzen]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Zet centen om naar de opmaak van de winkel: 5495 -> € 54,95 */
  function bedrag(centen, formaat) {
    var euro = (centen / 100).toFixed(2).replace('.', ',');
    if (formaat && formaat.indexOf('{{') !== -1) {
      return formaat.replace(/\{\{\s*[a-z_]+\s*\}\}/, euro);
    }
    return '€' + euro;
  }

  function aantalveld(wortel) {
    return (
      wortel.querySelector('.quantity-selector input[type="number"]') ||
      wortel.querySelector('quantity-selector input') ||
      wortel.querySelector('input[name="quantity"]')
    );
  }

  function zetAantal(veld, waarde) {
    if (!veld) return;
    veld.value = String(waarde);
    veld.dispatchEvent(new Event('input', { bubbles: true }));
    veld.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Welke variant staat er nu aan? We bouwen de titel uit de aangevinkte opties,
     want zo heet hij ook in de prijzenkaart: "150 x 200 cm / Saliegroen". */
  function huidigeVariant(wortel, data) {
    var invoer = wortel.querySelectorAll('input[data-option-name]:checked');
    var delen = [];
    for (var i = 0; i < invoer.length; i++) delen.push(invoer[i].value);
    var sleutel = delen.join(' / ');
    if (data.varianten[sleutel] !== undefined) return data.varianten[sleutel];

    // omgekeerde volgorde proberen, voor het geval de opties anders staan
    var omgekeerd = delen.slice().reverse().join(' / ');
    if (data.varianten[omgekeerd] !== undefined) return data.varianten[omgekeerd];
    return null;
  }

  function herreken(blok, wortel, data) {
    // het koopblok kan vervangen zijn; opnieuw zoeken vanaf het document
    var zoek = blok.closest('.product-details') || blok.closest('.product-information') || document;
    var prijs = huidigeVariant(zoek, data);
    if (prijs === null) prijs = huidigeVariant(document, data);
    if (prijs === null) return;

    var knoppen = blok.querySelectorAll('.nv-bundel__optie');
    for (var i = 0; i < knoppen.length; i++) {
      var knop = knoppen[i];
      var aantal = parseInt(knop.getAttribute('data-nv-aantal'), 10) || 1;
      var korting = parseInt(knop.getAttribute('data-nv-korting'), 10) || 0;

      /* Shopify past de korting per deken toe en rondt daar af, niet over het
         totaal. Zo rekenen wij ook, anders wijkt het bedrag in de winkelwagen
         een cent af van wat hier staat. */
      /* Shopify rekent per deken en rondt het KORTINGSBEDRAG naar beneden af,
         niet de prijs. 5% van 5495 is 274,75 en dat wordt 274 cent korting.
         Zo rekenen wij ook, anders wijkt het bedrag in de winkelwagen af. */
      var totaal = prijs * aantal;
      var afPerStuk = Math.floor(prijs * korting / 100);
      var perStuk = prijs - afPerStuk;
      var nieuw = perStuk * aantal;

      var elPer = knop.querySelector('[data-nv-perstuk]');
      var elNieuw = knop.querySelector('[data-nv-nieuw]');
      var elOud = knop.querySelector('[data-nv-oud]');

      if (elPer) elPer.textContent = bedrag(perStuk, data.valuta_formaat) + ' per stuk';
      if (elNieuw) elNieuw.textContent = bedrag(nieuw, data.valuta_formaat);
      if (elOud) elOud.textContent = bedrag(totaal, data.valuta_formaat);
    }
  }

  /* Welke korting geldt er bij dit aantal? De hoogste trede die je gehaald hebt.
     Zet iemand de teller handmatig op 5, dan telt de trede van 3 mee. */
  function tredeVoor(blok, aantal) {
    var knoppen = blok.querySelectorAll('.nv-bundel__optie');
    var beste = 0;
    var drempel = 0;
    for (var i = 0; i < knoppen.length; i++) {
      var n = parseInt(knoppen[i].getAttribute('data-nv-aantal'), 10) || 1;
      var k = parseInt(knoppen[i].getAttribute('data-nv-korting'), 10) || 0;
      if (aantal >= n && n >= drempel) {
        drempel = n;
        beste = k;
      }
    }
    return beste;
  }

  /* De totaalregel onderaan. Die volgt het aantalveld en niet de gekozen knop,
     want dat veld is wat er straks echt in de winkelwagen belandt. */
  function herrekenSom(blok, wortel, data) {
    var som = blok.querySelector('[data-nv-som]');
    if (!som) return;

    var zoek = blok.closest('.product-details') || blok.closest('.product-information') || document;
    var prijs = huidigeVariant(zoek, data);
    if (prijs === null) prijs = huidigeVariant(document, data);
    if (prijs === null) return;

    var veld = aantalveld(wortel) || aantalveld(document);
    var aantal = veld ? parseInt(veld.value, 10) || 1 : 1;
    if (aantal < 1) aantal = 1;

    var korting = tredeVoor(blok, aantal);
    var afPerStuk = Math.floor((prijs * korting) / 100);
    var oud = prijs * aantal;
    var nieuw = (prijs - afPerStuk) * aantal;

    var elNieuw = som.querySelector('[data-nv-som-nieuw]');
    var elOud = som.querySelector('[data-nv-som-oud]');
    var elBesp = som.querySelector('[data-nv-som-besparing]');

    if (elNieuw) elNieuw.textContent = bedrag(nieuw, data.valuta_formaat);

    if (elOud) {
      if (oud > nieuw) {
        elOud.textContent = bedrag(oud, data.valuta_formaat);
        elOud.hidden = false;
      } else {
        elOud.hidden = true;
      }
    }

    if (elBesp) {
      if (oud > nieuw) {
        elBesp.textContent = 'Je bespaart ' + bedrag(oud - nieuw, data.valuta_formaat);
        elBesp.hidden = false;
      } else {
        elBesp.hidden = true;
      }
    }
  }

  function markeer(blok, aantal) {
    var knoppen = blok.querySelectorAll('.nv-bundel__optie');
    for (var i = 0; i < knoppen.length; i++) {
      var raak = knoppen[i].getAttribute('data-nv-aantal') === String(aantal);
      knoppen[i].classList.toggle('is-gekozen', raak);
      knoppen[i].setAttribute('aria-pressed', raak ? 'true' : 'false');
    }
  }

  function koppel(blok) {
    if (blok.dataset.norvelaBundelGekoppeld === 'ja') return;
    var data = lees(blok);
    if (!data || !data.varianten) return;
    blok.dataset.norvelaBundelGekoppeld = 'ja';

    var wortel = blok.closest('.product-details') || blok.closest('.product-information') || document;

    blok.addEventListener('click', function (e) {
      var knop = e.target.closest('.nv-bundel__optie');
      if (!knop) return;
      var aantal = parseInt(knop.getAttribute('data-nv-aantal'), 10) || 1;
      zetAantal(aantalveld(wortel), aantal);
      markeer(blok, aantal);
      herrekenSom(blok, wortel, data);
    });

    /* Maat of kleur gewijzigd? Opnieuw uitrekenen.
       De luisteraar hangt bewust aan het document en niet aan het koopblok:
       Shopify vervangt dat blok bij een variantwissel, en dan verdwijnt een
       luisteraar die eraan hangt. */
    document.addEventListener('change', function (e) {
      var doel = e.target;
      if (!doel || !doel.getAttribute) return;
      if (!doel.getAttribute('data-option-name')) return;
      if (!document.contains(blok)) return;
      setTimeout(function () {
        herreken(blok, wortel, data);
        herrekenSom(blok, wortel, data);
      }, 60);
      setTimeout(function () {
        herreken(blok, wortel, data);
        herrekenSom(blok, wortel, data);
      }, 400);
    });

    /* Het aantalveld ook via het document volgen. De plus- en minknoppen van
       Shopify vervangen soms het hele veld, en dan is een luisteraar die aan
       dat ene veld hing verdwenen. */
    document.addEventListener('input', function (e) {
      var doel = e.target;
      if (!doel || doel.type !== 'number') return;
      if (!document.contains(blok)) return;
      markeer(blok, parseInt(doel.value, 10) || 1);
      herrekenSom(blok, wortel, data);
    });

    document.addEventListener('change', function (e) {
      var doel = e.target;
      if (!doel || doel.type !== 'number') return;
      if (!document.contains(blok)) return;
      markeer(blok, parseInt(doel.value, 10) || 1);
      herrekenSom(blok, wortel, data);
    });

    /* De plus- en minknoppen zijn een eigen Shopify-component die de waarde
       rechtstreeks in het veld zet. Javascript dat een waarde zo aanpast geeft
       geen input- of change-signaal af, dus daar hoorden we niets van. Vandaar
       dat we hier de klik zelf opvangen en daarna opnieuw uitrekenen. */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var knop = e.target.closest('quantity-selector-component button, .quantity-selector button');
      if (!knop) return;
      if (!document.contains(blok)) return;
      var lees = function () {
        var veld = aantalveld(wortel) || aantalveld(document);
        markeer(blok, veld ? parseInt(veld.value, 10) || 1 : 1);
        herrekenSom(blok, wortel, data);
      };
      setTimeout(lees, 0);
      setTimeout(lees, 120);
    });

    herreken(blok, wortel, data);
    herrekenSom(blok, wortel, data);
  }

  function start() {
    var blokken = document.querySelectorAll('[data-nv-bundel]');
    for (var i = 0; i < blokken.length; i++) koppel(blokken[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
